import { MutationTree } from 'vuex';
import { IContragentListState } from '@/store/interfaces';
import { ContragentDto } from '@/dto/Contragent.dto';

export const mutations: MutationTree<IContragentListState> = {
  SET_CONTRAGENT_LIST(state, payload: ContragentDto[]) {
    state.contragentList = payload;
  },
};
